<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @before-open="beforeOpen"
    />
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, getDetail, add, update, remove } from '@/api/env-monitor/station'

export default {
  name: 'env-monitor-station',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, getDetail, add, update, remove },
      option: {
        ...this.$store.state.publicOption,
        dialogWidth: '700px',
        viewBtn: true,
        column: [
          {
            label: '分站编号',
            prop: 'stationCode',
            search: true,
            rules: [{ required: true, message: '请输入分站编号', trigger: 'blur' }]
          },
          {
            label: '分站名称',
            prop: 'stationName',
            search: true,
            rules: [{ required: true, message: '请输入分站名称', trigger: 'blur' }]
          },
          {
            label: '在线状态',
            prop: 'onlineStatus',
            type: 'select',
            search: true,
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=env_monitor_point_status',
            props: { label: 'dictValue', value: 'dictKey' }
          },
          {
            label: '匹配状态',
            prop: 'matchStatus',
            search: true
          },
          {
            label: '最后采集时间',
            prop: 'lastCollectTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            addDisplay: false,
            editDisplay: false,
            minWidth: 170
          }
        ]
      }
    }
  }
}
</script>
